import { wrapRootElement as wrap } from './root-wrapper';
import Prism from 'prism-react-renderer/prism';

(typeof global !== 'undefined' ? global : window).Prism = Prism;

require('prismjs/components/prism-groovy');

export const wrapRootElement = wrap;
